export function formatFileSize(bytes) {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatDate(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateShort(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('it-IT');
}

const MIME_ICONS = {
  'application/pdf': { icon: 'PictureAsPdf', color: '#E53935' },
  'image/': { icon: 'Image', color: '#43A047' },
  'video/': { icon: 'VideoFile', color: '#8E24AA' },
  'audio/': { icon: 'AudioFile', color: '#FB8C00' },
  'text/': { icon: 'Description', color: '#1E88E5' },
  'application/zip': { icon: 'FolderZip', color: '#6D4C41' },
  'application/x-rar': { icon: 'FolderZip', color: '#6D4C41' },
  'application/vnd.openxmlformats-officedocument.wordprocessingml': { icon: 'Description', color: '#1565C0' },
  'application/vnd.openxmlformats-officedocument.spreadsheetml': { icon: 'TableChart', color: '#2E7D32' },
  'application/vnd.openxmlformats-officedocument.presentationml': { icon: 'Slideshow', color: '#D84315' },
  'application/msword': { icon: 'Description', color: '#1565C0' },
  'application/vnd.ms-excel': { icon: 'TableChart', color: '#2E7D32' },
  'application/vnd.ms-powerpoint': { icon: 'Slideshow', color: '#D84315' },
};

export function getMimeIcon(mimeType) {
  if (!mimeType) return { icon: 'InsertDriveFile', color: '#757575' };

  // Check exact match first
  if (MIME_ICONS[mimeType]) return MIME_ICONS[mimeType];

  // Check prefix match
  for (const [prefix, value] of Object.entries(MIME_ICONS)) {
    if (mimeType.startsWith(prefix)) return value;
  }

  return { icon: 'InsertDriveFile', color: '#757575' };
}
